import { computed, onMounted, onUnmounted, reactive, watch } from 'vue';
export default {
  components: {},
  props: {
    time: {
      type: Number,
      default: 10000,  //unit: timestamp
    },
    isStart: {   //是否開始倒數計時
      type: Boolean,
      default: false,
    },

  },
  setup(props, { emit }) {
    const { isStart } = props;



    const state = reactive({
      displayTime: '00:00:00',
      isReGenerate: 0,
    });

    const privateTime = computed({
      get: () => props.time,
      set: (val) => {
        emit('update:time', val);
      }
    });

    const privateisStart = computed({
      get: () => isStart,
      set: (val) => {
        emit('update:isStart', val);
      }
    });



    const millisecondsToHuman = (ms) => {
      // console.log('millisecondsToHuman ms', ms);
      let day = Math.floor(ms / (1000 * 60 * 60 * 24));
      let hour = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let min = Math.floor(ms / (1000 * 60)) % 60;
      let sec = Math.floor(ms / 1000) % 60;
      let dayPrev = day ? day + 'days' : '';
      let hourPrev = hour < 10 ? '0' : '';
      let minPrev = min < 10 ? '0' : '';
      let minSec = sec < 10 ? '0' : '';
      // console.log(hour, min, sec, minPrev)
      return dayPrev + " " + hourPrev + hour + ":" + minPrev + min + ":" + minSec + sec;
    }

    const handleTime = (targetTime) => {
      // console.log('targetTime', targetTime);
      // console.log('currentTime', Date.now());
      return targetTime <= Date.now() ? '00:00:00' : millisecondsToHuman(targetTime - Date.now());
    }


    const initTime = () => {
      state.displayTime = handleTime(props.time);
    }

    let interval = null;

    const countDown = () => {
      // console.log('isReGenerate', state.isReGenerate)
      if (state.isReGenerate > 1) { //按超過一次
        clearInterval(interval);
      }
      let s = 1000;  // 1 seconds 
      interval = setInterval(() => {
        privateisStart.value = false;
        state.displayTime = handleTime(props.time);
        if (state.displayTime === '00:00:00') clearInterval(interval);
      }, s); // end: setInterval


    }//end: countDown

    watch(
      () => props.isStart,
      (val) => {
        if (val) {
          state.isReGenerate++;
          // console.log('watch isStart', val, state.isReGenerate)
          countDown();
        }//end: if
      }, {
      deep: true, immediate: true,
    }) //end: wath

    watch(
      () => state.displayTime,
      (val) => {
        if (val === '00:00:00') {
          emit('finish');
        }
      }
    )

    onMounted(() => {
      initTime();
    });

    onUnmounted(() => {
      clearInterval(interval);
      console.log('onUnmounted')
    });



    return {
      state,
      privateTime,
      privateisStart,

    }//end: return
  }
}


